<template>
  <v-container>
    <v-card color="card" class="rounded-xl" elevation="7">
      <v-toolbar color="toolbar">
        <v-toolbar-title> Configure Slideshows </v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-card-title>My Slideshows</v-card-title>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="slideshow in slideshows"
            :key="slideshow.id"
          >
            <v-expansion-panel-header color="toolbar">
              {{ slideshow.name }}
              <div style="float: right">
                <v-btn icon @click="deleteRule(rule.id)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content color="toolbar">
              <v-card-text>
                <v-text-field
                  disabled
                  label="Share Link"
                  :value="
                    'https://images.flowinity.com/slideshow/' +
                    slideshow.shareLink
                  "
                />
                <v-text-field label="Slideshow Name" v-model="slideshow.name" />
                <v-text-field
                  label="Speed/Interval (in s, can do decimals)"
                  v-model="slideshow.speed"
                />
                <v-switch
                  inset
                  label="Include items from my gallery"
                  v-model="slideshow.includeGallery"
                ></v-switch>
                <v-select
                  v-model="slideshow.collectionIds"
                  :items="collections"
                  label="Collections"
                  chips
                  deletable-chips
                  multiple
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-card-text>

              <v-sheet outlined color="toolbar" class="rounded-xxl mt-3">
                <v-card
                  max-width="100%"
                  height="50"
                  outlined
                  class="rounded-xxl"
                  @click="saveSlideshow(slideshow)"
                >
                  <v-icon style="width: 100%; height: 100%" size="30"
                    >mdi-content-save</v-icon
                  >
                </v-card>
              </v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-subtitle v-if="!slideshows.length"
          >No slideshows found</v-card-subtitle
        >
        <v-sheet outlined color="toolbar" class="rounded-xxl mt-3">
          <v-card
            max-width="100%"
            height="50"
            outlined
            class="rounded-xxl"
            @click="createSlideshow()"
          >
            <v-icon style="width: 100%; height: 100%" size="50"
              >mdi-plus</v-icon
            >
          </v-card>
        </v-sheet>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "SettingsSlideshow",
  data() {
    return {
      slideshows: [],
      collections: []
    }
  },
  methods: {
    saveSlideshow(slideshow) {
      this.axios
        .put("/api/v1/slideshow/" + slideshow.id, slideshow)
        .catch((err) => {
          AjaxErrorHandler(err)
        })
    },
    getCollections() {
      this.axios
        .get("/api/v1/collections")
        .then((res) => {
          this.collections = res.data.rows
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getSlideshows() {
      this.axios.get("/api/v1/slideshow").then((res) => {
        this.slideshows = res.data
      })
    },
    createSlideshow() {
      this.axios
        .post("/api/v1/slideshow", {
          name: "New Slideshow",
          includeGallery: true,
          collectionIds: []
        })
        .then(() => {
          this.getSlideshows()
        })
    }
  },
  mounted() {
    this.getSlideshows()
    this.getCollections()
  }
}
</script>

<style scoped></style>
